module.exports = __webpack_public_path__ + "static/media/Alberto.720c876f.png";